import { render, staticRenderFns } from "./OtherIncomeEditForm.vue?vue&type=template&id=23ae628e"
import script from "./OtherIncomeEditForm.vue?vue&type=script&lang=js"
export * from "./OtherIncomeEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports